import { Component, Inject, inject } from "@angular/core";
import { SafeUrlPipe } from "../../../../../shared/src/lib/pipe/safe-url.pipe";
import { ActivatedRoute } from "@angular/router";
import { MatIcon } from "@angular/material/icon";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";

@Component({
    selector: "app-full-screen-tv",
    imports: [SafeUrlPipe, MatIcon],
    templateUrl: "./full-screen-tv.component.html",
    styleUrl: "./full-screen-tv.component.scss"
})
export class FullScreenTvComponent {
  dialogRef = inject(MatDialogRef);
  route = inject(ActivatedRoute);

  constructor(@Inject(MAT_DIALOG_DATA) public data: any) {}
}
